import React, { useState } from 'react';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CommonClasses from 'Styles/Common.module.css';
import TutorClasses from '../../Categories/addCategory/index.module.css';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Services } from 'Services';
import ReactLoading from 'react-loading';
import { BsCloudUpload } from 'react-icons/bs';
import GiftClasses from '../../gifts/Gifts.module.css'
import { Success, Error } from 'Util/Toast';
import { useFileUpload } from 'Util/fileUpload';


const AddCategory = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState('');
    const [imagePreview, setImagePreview] = useState('');

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    const { uploadWithLoading } = useFileUpload({
        allowedTypes: ["image/png", "image/jpeg", "image/webp"],
        maxSizeInMB: 10,
        folder: "Categories"
    });


    const filehandleChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setLoading(true);
        try {
            await uploadWithLoading(
                file,
                (uploadedFile) => {
                    // Success callback
                    setImage(uploadedFile.fileUrl); // Full URL for preview
                    setImagePreview(URL.createObjectURL(file)); // Blob URL for preview
                    setValue('CategoryImage', uploadedFile.fileName); // Store just filename for API
                },
                (error) => {
                    console.error("Upload Error:", error);
                }
            );
        } finally {
            setLoading(false);
        }
    };


    const onSubmit = async (body) => {
        if (!image) {
            // Show error message if image is not uploaded
            Error('Please upload an image.');
            return;
        }

        setLoading(true);
        try {
            // Extract filename from image
            const filename = image.split('/').pop();

            // Add filename to data
            body.image = filename;

            const token = { Authorization: `token ${localStorage.getItem('token')}` };
            const response = await Services.addCategory("POST", JSON.stringify(body), token);
            if (response.Status === 1) {
                // Category added successfully
                setLoading(false);
                // Redirect to a different page or perform any other action
                navigate('/categories');
                Success(response.Message);
            } else {
                // Handle error
                setLoading(false);
                Error(response.Message);
            }
        } catch (error) {
            console.error('Error adding category:', error);
            setLoading(false);
            Error('Error adding category');
        }
    };

    const fileuploadDesign = (
        <div className={TutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={TutorClasses['upload-image']}>
                {imagePreview && <img src={imagePreview} alt="Selected" className={TutorClasses['uploaded-coupon-image']} />}
                {!imagePreview && (
                    <div className={TutorClasses['add-item']}>
                        <BsCloudUpload className={TutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png will be accepted)</p>
                    </div>
                )}
                <input type="file" id="image" onChange={filehandleChange} style={{ display: 'none' }} />
            </div>
        </div>
    );

    return (
        <Layout Active={'Categories'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Category</title>
            </Helmet>
            <div className={CommonClasses['Container']}>
                <div className={CommonClasses["control-btns"]}>
                    <button className={CommonClasses["button"]} onClick={() => navigate(-1)}>Back</button>
                </div>
                <div className={TutorClasses['wrapper']} data-aos="zoom-in-down">
                    <h2 className={TutorClasses['main-header']}>Create Category</h2>
                    <form className={TutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="CategoryName">Category Name</label>
                            <input type='text' {...register('CategoryName', { required: 'Please enter a category name.' })} />
                            {errors.CategoryName && <p className={GiftClasses["error-message"]}>{errors.CategoryName.message}</p>}
                        </div>
                        <div className={TutorClasses['file-upload-wrapper']}>
                            <header>
                                <h3>
                                    Upload Category Image <span className="important">*</span>
                                </h3>
                            </header>
                            <div className={TutorClasses["upload-image"]} required>
                                {fileuploadDesign}
                            </div>
                            {errors.CategoryImage && <p className={GiftClasses["error-message"]}>Please upload a category image.</p>}
                        </div>
                        {/* Add more input fields for other properties */}
                        <button disabled={loading}>
                            {loading ? (
                                <ReactLoading color="green" type="spokes" height={30} width={30} />
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default AddCategory;
